/**
 * This file is shared between pok-core & pok-web
 * If you have to change it then do it in pok-core and run yarn get:validation-schemas @pok-web
 */

export enum SalesInvoiceStatusEnum {
  Draft = 'Draft',
  Approved = 'Approved',
  InKSeF = 'InKSeF',
}

export enum SalesInvoiceStatusEnumText {
  Draft = 'Szkic',
  Approved = 'Zatwierdzona',
  InKSeF = 'W KSeF',
}

export enum JudgmentNumberingTypeEnum {
  Judgment = 'Judgment',
  Card = 'Card',
  SalesInvoice = 'SalesInvoice',
  SalesInvoiceCorrected = 'SalesInvoiceCorrected',
}

export enum PaymentFormEnum {
  Cash = 'Cash',
  BankTransfer = 'BankTransfer',
  Card = 'Card',
  Mobile = 'Mobile',
}

export enum PaymentFormEnumText {
  Cash = 'Gotówka',
  BankTransfer = 'Przelew',
  Card = 'Karta',
  Mobile = 'Płatność mobilna',
}

export enum KSEFStatusEnum {
  AcceptedInKSeF = 'AcceptedInKSeF',
  RejectedInKSeF = 'RejectedInKSeF',
  WaitingForKSeF = 'WaitingForKSeF',
}

export enum KSEFRoleEnum {
  Factor = 'Factor',
  Recipient = 'Recipient',
  OriginalEntity = 'OriginalEntity',
  AdditionalBuyer = 'AdditionalBuyer',
  PaymentEntity = 'PaymentEntity',
  Payer = 'Payer',
  LocalGovernmentIssuer = 'LocalGovernmentIssuer',
  LocalGovernmentRecipient = 'LocalGovernmentRecipient',
  VATGroupMemberIssuer = 'VATGroupMemberIssuer',
  VATGroupMemberRecipient = 'VATGroupMemberRecipient',
  Employee = 'Employee',
  OtherEntity = 'OtherEntity',
}

export enum KSEFRoleEnumText {
  Factor = 'Faktor',
  Recipient = 'Odbiorca',
  OriginalEntity = 'Podmiot pierwotny',
  AdditionalBuyer = 'Dodatkowy nabywca',
  PaymentEntity = 'Wystawca faktury',
  Payer = 'Dokonujący płatności',
  LocalGovernmentIssuer = 'JST – wystawca',
  LocalGovernmentRecipient = 'JST – odbiorca',
  VATGroupMemberIssuer = 'Członek Grupy VAT – wystawca',
  VATGroupMemberRecipient = 'Członek Grupy VAT – odbiorca',
  Employee = 'Pracownik',
  OtherEntity = 'Inny podmiot',
}

export enum KSEFRoleEnumNumber {
  Factor = '1',
  Recipient = '2',
  OriginalEntity = '3',
  AdditionalBuyer = '4',
  PaymentEntity = '5',
  Payer = '6',
  LocalGovernmentIssuer = '7',
  LocalGovernmentRecipient = '8',
  VATGroupMemberIssuer = '9',
  VATGroupMemberRecipient = '10',
  Employee = '11',
  OtherEntity = '12',
}

export enum SimP1StatusEnum {
  ToSign = 'ToSign',
  WaitingForP1 = 'WaitingForP1',
  AcceptedInP1 = 'AcceptedInP1',
  RejectedInP1 = 'RejectedInP1',
  ValidationFailed = 'ValidationFailed',
}

export enum SimP1DocumentTypeEnum {
  Judgment = 'Judgment',
  Cancellation = 'Cancellation',
}

export enum SimP1StatusEnumText {
  ToSign = 'Do podpisu',
  WaitingForP1 = 'Oczekuje na wysłanie do SIM',
  AcceptedInP1 = 'Przyjęto w SIM',
  RejectedInP1 = 'Odrzucono w SIM',
  ValidationFailed = 'Niekompletne – błąd walidacji P1',
}

export enum VatEnum {
  '23%' = '23%',
  '8%' = '8%',
  '5%' = '5%',
  '0% KR' = '0% KR',
  'zw.' = 'zw.',
}

export enum PrinterJpkDocumentTypeEnum {
  Paragon = 'Paragon',
  Raport = 'Raport',
  Inne = 'Inne',
}

export enum ReceiptTypeEnum {
  Fiscal = 'Fiscal',
  EFiscal = 'EFiscal',
}

export enum ReceiptTypeEnumText {
  Fiscal = 'Fiskalny',
  EFiscal = 'e-paragon',
}

export enum InvoicePaymentLinkTypeEnum {
  Invoice = 'Invoice',
  Withdrawal = 'Withdrawal',
  Return = 'Return',
  Correction = 'Correction',
}

export enum InvoicePaymentLinkEnumText {
  Invoice = 'Faktura',
  Withdrawal = 'Wyprowadzono poza system',
  Return = 'Zwrot',
  Correction = 'Korekta',
}

export enum InvoicePaymentOriginEnum {
  PatientPortal = 'PatientPortal',
  BatchPayment = 'BatchPayment',
  SinglePayment = 'SinglePayment',
  Receipt = 'Receipt',
  PaidInvoice = 'PaidInvoice',
}

export enum InvoicePaymentOriginEnumText {
  PatientPortal = 'Portal badanego',
  BatchPayment = 'Wpłata zbiorcza',
  SinglePayment = 'Wpłata pojedyncza',
  Receipt = 'Paragon',
  PaidInvoice = 'Zapłacona faktura',
}

export enum CoreFieldNameEnum {
  harmfulFactorsSysNo = 'harmfulFactorsSysNo',
}
